
import { useState } from 'react';

export default function ConsultationFAQ() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "How do I prepare for my consultation?",
      answer: "Come prepared with your investment goals, budget range, timeline, and any specific questions. If you have property locations in mind, bring those details. We'll send you a preparation checklist after booking."
    },
    {
      question: "Can consultations be conducted remotely?",
      answer: "Yes! We offer both in-person and virtual consultations via video call. Virtual consultations are just as comprehensive and allow us to share screens for presentations and documents."
    },
    {
      question: "What happens after the consultation?",
      answer: "You'll receive a detailed summary of our discussion, recommended next steps, and relevant resources. If you decide to move forward, we'll provide a customized action plan and ongoing support options."
    },
    {
      question: "Do you offer follow-up consultations?",
      answer: "Absolutely! Many clients benefit from follow-up sessions as their projects progress. We offer discounted rates for returning clients and can create ongoing advisory packages."
    },
    {
      question: "What if I need to reschedule my consultation?",
      answer: "We understand schedules change. You can reschedule up to 24 hours before your appointment without any fees. Less than 24 hours notice may incur a rescheduling fee."
    },
    {
      question: "Are consultation fees refundable?",
      answer: "Consultation fees are non-refundable once the session is completed. However, if you need to cancel more than 48 hours in advance, we offer a full refund or credit toward future services."
    },
    {
      question: "Can I bring partners or team members to the consultation?",
      answer: "Yes! We encourage bringing key decision-makers. There's no additional charge for additional attendees, and it often makes the consultation more productive."
    },
    {
      question: "Do you provide written recommendations?",
      answer: "Every consultation includes a written summary with key recommendations, action items, and relevant resources. More detailed reports can be provided for an additional fee if needed."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our consultation services
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-xl text-emerald-600 flex-shrink-0`}></i>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 bg-emerald-600 rounded-xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">Still Have Questions?</h3>
          <p className="text-emerald-100 mb-6">
            Our team is here to help you choose the right consultation service for your needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact"
              className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </a>
            <a 
              href="tel:+1-256-268-7146"
              className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Call Now
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
